import { Injectable } from '@angular/core';
import { GridDataService } from '../../../../gk-kendo';
import { WladajacyResponseDto } from '../../../../gk-map/models';

@Injectable({
  providedIn: 'any',
})
export class FspPremissesOwnerGridDataService extends GridDataService<WladajacyResponseDto> {
  constructor() {
    super(undefined, 'GET');
  }
}
